// Fetch list

export const FETCH = 'reportCostCenterCosts.FETCH'
export const FETCH_STARTED = 'reportCostCenterCosts.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportCostCenterCosts.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportCostCenterCosts.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportCostCenterCosts.FETCH_CANCELLED'

// Export

export const EXPORT = 'reportCostCenterCosts.EXPORT'
export const EXPORT_FULFILLED = 'reportCostCenterCosts.EXPORT_FULFILLED'

// Clear

export const CLEAR = 'reportCostCenterCosts.CLEAR'

// Fetch details

export const FETCH_DETAILS = 'reportCostCenterCosts.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportCostCenterCosts.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportCostCenterCosts.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportCostCenterCosts.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportCostCenterCosts.FETCH_DETAILS_CANCELLED'

// Export details

export const EXPORT_DETAILS = 'reportCostCenterCosts.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportCostCenterCosts.EXPORT_DETAILS_FULFILLED'

// Clear details

export const CLEAR_DETAILS = 'reportCostCenterCosts.CLEAR_DETAILS'
